const FONT_FAMILY = '"Noto Sans", Roboto, sans-serif';

/**
 * The cap every applied-filter chip is clipped to; the summary decision is
 * measured against it.
 */
export const APPLIED_FILTER_CHIP_MAX_WIDTH = 240;

/**
 * Gap between chips in the toolbar row, in px — `gap={2}` at the theme's
 * `spacing: 4`.
 */
export const APPLIED_FILTER_CHIP_GAP = 8;

/**
 * Horizontal space a chip spends on everything but its two texts: 12px
 * padding on the left, 8px on the right once the ⓧ's -4px margin is counted,
 * the 4px gap between label and summary, the 4px gap before the ⓧ control,
 * and the 16px control. Mirrors the `filter` chip variant in
 * `src/theme/muiTheme.tsx`.
 */
export const APPLIED_FILTER_CHIP_HORIZONTAL_CHROME = 12 + 8 + 4 + 4 + 16;

/**
 * The chip summary's font as a canvas shorthand — the theme's `body1`, which
 * is the design's Body text token.
 */
export const APPLIED_FILTER_CHIP_FONT = `400 14px ${FONT_FAMILY}`;

/**
 * The bold category label's font as a canvas shorthand — the theme's `h5`,
 * which is the design's H5 token.
 */
export const APPLIED_FILTER_CHIP_LABEL_FONT = `600 14px ${FONT_FAMILY}`;
